module.exports = __webpack_public_path__ + "img/icon3.fb192207.png";